export const SupportLinks = {
    EXPERT_CALLS: `https://win.varos.com/en/articles/9554103-varos-expert-calls`,
    REWARDS_LEARN_MORE: `https://win.varos.com/en/articles/9554103-varos-expert-calls`,
};
